exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".background-image[data-v-1939a7b0]{bottom:0;left:0;right:0;top:0}", ""]);

